"use strict";

exports.__esModule = true;
exports["default"] = getDates;

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

var _add_days = _interopRequireDefault(require("date-fns/add_days"));

var _add_months = _interopRequireDefault(require("date-fns/add_months"));

var _end_of_month = _interopRequireDefault(require("date-fns/end_of_month"));

var _end_of_year = _interopRequireDefault(require("date-fns/end_of_year"));

var _get_day = _interopRequireDefault(require("date-fns/get_day"));

var _is_before = _interopRequireDefault(require("date-fns/is_before"));

var _start_of_month = _interopRequireDefault(require("date-fns/start_of_month"));

var _start_of_year = _interopRequireDefault(require("date-fns/start_of_year"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function addOneBy(increment, date) {
  if (increment === 'months') {
    return (0, _add_months["default"])(date, 1);
  }

  return (0, _add_days["default"])(date, 1);
}

function getDateRangeBy(increment, start, end) {
  var dates = [];

  for (var date = start; (0, _is_before["default"])(date, end); date = addOneBy(increment, date)) {
    dates.push(date);
  }

  return dates;
}

function splitByWeek(dates) {
  var month = [];
  var currentWeek = 0;
  var firstDay = (0, _get_day["default"])(dates[0]);

  if (firstDay !== 0) {
    var _month$;

    month.push([]);

    (_month$ = month[0]).push.apply(_month$, Array.from({
      length: firstDay
    }));
  } else {
    currentWeek = -1;
  }

  dates.forEach(function (date) {
    if ((0, _get_day["default"])(date) === 0) {
      month.push([]);
      currentWeek += 1;
    }

    month[currentWeek].push(date);
  });
  return month;
}

function splitByQuarter(months) {
  var year = [[]];
  var currentQuarter = 0;
  var count = 0;
  months.forEach(function (month) {
    if (count === 3) {
      year.push([]);
      currentQuarter += 1;
      count = 0;
    }

    year[currentQuarter].push(month);
    count += 1;
  });
  return year;
}

function getMonth(date) {
  var start = (0, _start_of_month["default"])(date);
  var end = (0, _end_of_month["default"])(date);
  var dateRange = getDateRangeBy('days', start, end);
  return splitByWeek(dateRange);
}

function getYear(date) {
  var start = (0, _start_of_year["default"])(date);
  var end = (0, _end_of_year["default"])(date);
  var monthRange = getDateRangeBy('months', start, end);
  return splitByQuarter(monthRange);
}

function getDates(date, mode) {
  if (mode === 'month') {
    return getMonth(date);
  }

  return getYear(date);
}